// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  localApiUrl: window['env']?.['localApiUrl'] || 'http://localhost:4200/',
  pesataHubUrl: window['env']?.['pesataHubUrl'] || 'http://localhost:4600/',
  //localApiUrl: 'https://api-local-v2.archiconnect.it/',
  //pesataHubUrl: 'https://hub-pesata.archiconnect.it/'

  // Mappa pianifiche (Leaflet + OpenStreetMap, gratuiti e senza API key)
  mapTileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  mapTileAttribution: '&copy; OpenStreetMap contributors',
  mapRouteUrl: 'https://router.project-osrm.org/route/v1/driving/'
};
